import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-notification-empty',
  imports: [],
  template: `
    <img class="image" src="assets/img/empty-object-light.svg" />
    <span style="font-weight: 600">No notifications!</span>
    <span class="hint">
      When you get assigned a new activity, a notification will show up in this space
    </span>
  `,
  styles: `
    :host {
      height: 258px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .image {
      margin-bottom: auto;
    }
    .hint {
      text-align: center;
      margin-bottom: 30px;
      color: var(--color-basic-neutral-60);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationEmptyComponent {}
